import * as React from "react";
import {SVGProps} from "react";
const SvgTwitter = (props: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 22 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M18.995 2.688A4.3 4.3 0 0 0 20.882.314a8.59 8.59 0 0 1-2.725 1.041 4.3 4.3 0 0 0-7.316 3.915A12.184 12.184 0 0 1 1.997.786a4.3 4.3 0 0 0 1.328 5.73 4.276 4.276 0 0 1-1.943-.538v.054a4.294 4.294 0 0 0 3.443 4.208 4.3 4.3 0 0 1-1.938.074 4.3 4.3 0 0 0 4.009 2.98 8.61 8.61 0 0 1-5.33 1.837c-.343 0-.685-.02-1.025-.059A12.148 12.148 0 0 0 7.12 17 12.127 12.127 0 0 0 19.33 4.789c0-.186-.004-.371-.013-.555a8.718 8.718 0 0 0 2.142-2.222 8.58 8.58 0 0 1-2.464.676Z" />
    </svg>
);
export default SvgTwitter;
